import { safeParseDate } from "@/lib/utils/date/date";
import {
  getAppointmentCalendarDate,
  parseAppointmentApiDateTime,
} from "@/lib/utils/date/appointment-datetime";

const APPOINTMENT_DATE_LOCALE = "en-US";

const APPOINTMENT_BOOKING_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

const APPOINTMENT_BOOKING_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
};

export function formatAppointmentBookingDate(
  value: Date | string | null | undefined,
): string {
  const calendarDate = getAppointmentCalendarDate(value);
  if (!calendarDate) return "-";
  return calendarDate.toLocaleDateString(
    APPOINTMENT_DATE_LOCALE,
    APPOINTMENT_BOOKING_DATE_OPTIONS,
  );
}

export function formatAppointmentBookingDateLong(
  value: Date | string | null | undefined,
): string {
  const calendarDate = getAppointmentCalendarDate(value);
  if (!calendarDate) return "-";
  return calendarDate.toLocaleDateString(APPOINTMENT_DATE_LOCALE, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatAppointmentBookingTime(
  value: Date | string | null | undefined,
): string {
  const date = parseAppointmentApiDateTime(value) ?? safeParseDate(value);
  if (!date) return "-";
  return date.toLocaleTimeString(
    APPOINTMENT_DATE_LOCALE,
    APPOINTMENT_BOOKING_TIME_OPTIONS,
  );
}

export function formatAppointmentBookingTimeRange(
  start: Date | string | null | undefined,
  end: Date | string | null | undefined,
): string {
  return `${formatAppointmentBookingTime(start)} - ${formatAppointmentBookingTime(end)}`;
}
